import { Component, Input, OnChanges, SimpleChanges }      from '@angular/core';
import { FormBuilder, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { HttpErrorResponse }                               from '@angular/common/http';

import { catchError } from 'rxjs/operators';

import { ToastrService } from 'ngx-toastr';

import { Mask }                                  from '@models/utils/mask';
import { contactSubject, contactSubjectOptions } from '@models/utils/contact-subject';
import { AuthUser }                              from '@models/user/auth-user';

import { defaultPhoneMask }    from '@utils/masks/phone-mask';
import { emailValidatorRegex } from '@utils/validators/email-validator-regex';
import { phoneValidatorRegex } from '@utils/validators/phone-validator-regex';

import { ErrorService }      from '@utils/error/error.service';
import { ApiContactService } from '@services/api-contact.service';


@Component({
  selector:    'red-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls:   [ './contact-form.component.scss' ]
})
export class ContactFormComponent implements OnChanges {

  public contactForm:    FormGroup;
  public phoneMask:      Mask;
  public subjectOptions: contactSubject[];
  public isEmailSent:    boolean;

  @Input() user:      AuthUser;
  @Input() hasSchool: boolean;

  constructor(
    private formBuilder:      FormBuilder,
    private toastr:           ToastrService,
    private errorService:     ErrorService,
    private contactService:   ApiContactService,
  ) {
    this.isEmailSent    = false;
    this.phoneMask      = defaultPhoneMask;
    this.subjectOptions = contactSubjectOptions;

    const emailValidators: ValidatorFn[]  = [ Validators.required, Validators.pattern(emailValidatorRegex) ],
          phoneValidators: ValidatorFn[]  = [ Validators.pattern(phoneValidatorRegex) ],
          schoolValidators: ValidatorFn[] = this.hasSchool ? [ Validators.required ] : [];

    this.contactForm = this.formBuilder.group(
      {
        nome:     this.formBuilder.control('', [ Validators.required ]),
        escola:   this.formBuilder.control('', schoolValidators),
        email:    this.formBuilder.control('', emailValidators),
        telefone: this.formBuilder.control('', phoneValidators),
        assunto:  this.formBuilder.control('', [ Validators.required ]),
        mensagem: this.formBuilder.control('', [ Validators.required ])
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['user']) {
      this.contactForm.get('nome').patchValue(this.user?.nome);
      this.contactForm.updateValueAndValidity();
    }
  }

  public submitContactForm() {
    if (this.contactForm.invalid) return;

    this.contactForm.disable();

    const handleError = (error: HttpErrorResponse) => {
      this.contactForm.enable();
      return this.errorService.handleFormError(error);
    };

    this.contactService.postContact(this.contactForm.value).pipe(
      catchError(handleError)
    ).subscribe(() => {
      this.toastr.success(
        'Nossa equipe entrará em contato assim que possível.',
        'Seu contato foi enviado',
        { timeOut: 10000 }
      );

      this.isEmailSent = true;
      this.contactForm.enable();
    });
  }

}
